import React from 'react';
import { BarcodeScanner } from '@capacitor-community/barcode-scanner';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Box, Center, Flex, Text } from '@chakra-ui/react';
import ReactDOM from 'react-dom';

export type BarcodeScannerOverlayProps = {
  title?: string;
};

export function BarcodeScannerOverlay(props: BarcodeScannerOverlayProps) {
  return ReactDOM.createPortal(<BarcodeScannerOverlayUI {...props} />, document.body);
}

/**
 * UI displayed on top of the camera, when opened to scan a barcode.
 * @constructor
 */
function BarcodeScannerOverlayUI({ title = 'Scan QR Code' }: BarcodeScannerOverlayProps) {
  async function handleClose() {
    await BarcodeScanner.stopScan();
    document.body.classList.remove('qrscanner');
  }

  return (
    <Box className={'scanner-ui'}>
      <Center h={'100%'} w={'100%'} flexDirection={'column'}>
        <Box
          top={'env(safe-area-inset-top)'}
          alignSelf={'flex-start'}
          justifySelf={'flex-start'}
          color={'white'}
          position={'absolute'}
          w="100%"
        >
          <Flex position={'relative'} w="100%" align="center" justify={'center'} mt={4}>
            <Box color={'white'} position={'absolute'} left={5} as={'button'} onClick={handleClose}>
              <ChevronLeftIcon w={'26px'} h={'26px'} />
            </Box>
            <Text>{title}</Text>
          </Flex>
        </Box>
        <Box
          opacity={1}
          h={'40vh'}
          w={'90vw'}
          rounded={10}
          background={'transparent'}
          boxShadow={'0 0 0 99999px rgba(0, 0, 0, 0.6)'}
          border={'1px solid black'}
        />
      </Center>
    </Box>
  );
}
